import React from 'react';
import { Navbar,Nav,Button,Form,FormControl } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import 'bootstrap/dist/css/bootstrap.min.css';
import r from './img/img.png' ;
import './App.css';

import Switch from 'react-switch';
import reactLogo from './assets/logo.svg';
import {Card,CardDeck } from 'react-bootstrap';
import n_1 from './img/1.png';
import n_2 from './img/2.jpg';
import n_3 from './img/3.png';
import Header from './header'

const mystyle = {
  fontFamily: "Arial",
  fontWeight:'bold'

};

 export  default class MainPage extends React.Component {
  
  render() {
    
    return (
      <div className="header">
<Header/>

    <br/>    
    <br/>

    <h2>Creer un portolio digital en ligne gratuitement</h2>
    <br/>
    <div className="row justify-content-center pb-4 pb-xl-5 pt-4 ">
    <div className="col-md-6 col-xlg-4 justify-content-center mb-4 mb-xl-0">
    <img src={r} className="image"/>
    <br/>
    <br/>
    <br/>
    <br/>
        </div>
        <div className="col-md-4 col-xlg-5 offset-xlg-1 text-md-left ">
        <h2>Tout ce dont vous avez besoin pour créer un e-portofolio professionnel</h2>
        <br/>
<p className="texte" >
Un bon portfolio numérique met un coup de projecteur sur votre travail. PortfolioMaker vous aide à présenter votre travail de manière professionnelle avec des portfolios numériques beaux et personnalisés créés en quelques minutes.
Créez un e-portofolio qui impressionnera vos clients.
</p>
<Button variant="dark" href="/create" className="publier" style={{fontSize:'18px'}}>Publier des maintenant &nbsp;&nbsp;</Button>

        </div>
    </div>
    
    
    <div  className="jaj" style={{fontSize:'18px'}}>
    <br/><br/>
<h2><strong>Comment créer un portofolio digital</strong></h2>
<br/>
<p className="texte">Voici les etapes pour la creation de votre portfolio: </p>
<div className="container-fluid">
<ol class="row justify-content-center list-unstyled p-0 mb-0">
  <li class="col-sm-6 col-md-3 mb-4">
    <p><img src="https://cdn.flipsnack.com/site/images/landing-circle/1.gz.svg" alt="Design / Téléchargement"/>
      </p>
      <h4 style={{fontSize:'17px'}}><strong>Design / Téléchargement</strong></h4>
      <p>Créez votre portofolio digital en PDF et téléchargez-le, ou bien créez-en un avec notre éditeur</p>
      </li><li class="col-sm-6 col-md-3 mb-4">
        <p><img src="https://cdn.flipsnack.com/site/images/landing-circle/2.gz.svg" alt="Changements des réglages"/>
          </p><h4 style={{fontSize:'17px'}}><strong>Changements des réglages</strong></h4><p>Personnalisez les réglages selon vos besoins et autorisez le téléchargement</p>
            </li><li class="col-sm-6 col-md-3 mb-4"><p><img src="https://cdn.flipsnack.com/site/images/landing-circle/3.gz.svg" alt="Publiez / Partagez"/>
            </p><h4 style={{fontSize:'17px'}}><strong>Publiez / Partagez</strong></h4><p>Une fois publié, vous pouvez partager votre e-portofolio, par mail, sur les réseaux sociaux ou intégré</p>
</li>
  </ol>

</div>
<br/><br/>

<div className="template" >
  <br/>
<h2><strong>Des exemples de portfolio digitaux professionnels & modèles</strong></h2>
<p>Une manière facile et rapide pour la création</p>
<br/><br/>

<ol  class="row justify-content-center list-unstyled p-0 mb-0">
<li class="col-sm-6 col-md-3 mb-4">    <img src={r} className="image1"/>
</li>&nbsp;&nbsp;
<li class="col-sm-6 col-md-3 mb-4">    <img src={r} className="image1"/>
</li><li class="col-sm-6 col-md-3 mb-4">    <img src={r} className="image1"/>
</li>

</ol>
<p >Nous offrons des modèles à personnaliser de portfolio pour alléger votre travail.
   Avant de commencer à personnaliser nos modèles avec vos propres textes et images,
    il est plus efficace que vous créiez un dossier spécifique avec tous les projets que vous souhaitez ajouter à votre portfolio.
     C’est plus efficace de cette manière.</p>
<Button variant="outline-dark" style={{fontSize:'18px'}}>Editer une des template</Button>
<br/><br/>

</div>

      </div>
      <footer className='footer mt-auto py-3 bg-light text-dark'>
        <div className='container'>Place sticky footer content here.</div>
      </footer>
      </div>
     
      
    );
  }
}
